import _ from 'lodash';
import { fetchStudentRollNoApi } from '../../../apis/rollNoUpdate';

const transformResponse = (allData: any[]) => {
  const result = allData.map((data) => ({
    name: data.student.name,
    enrollmentNo: data.student.enrollmentNo,
    rollNo: data.student.rollNo,
    id: data.student.id,
    email: data.student.email,
    status: data.student.status,
    profile: data.student.profile
  }));
  return result;
};

export const fetchAllStudentRollNo = async (params: any) => {
  const perPage = 400;
  let pageNo = 1;
  let allData: any[] = [];
  while (true) {
    const response = await fetchStudentRollNoApi(params, pageNo, perPage);
    const pageData = response || [];
    if (_.isEmpty(pageData)) break;
    allData = allData.concat(pageData);
    pageNo++;
  }
  return transformResponse(allData);
};
